import * as React from "react";
import Container from "@mui/material/Container";
import { fontBrand } from "../../../../getLPTheme";
import { Typography, Box, Stack } from "@mui/material";
import Pays from "./billsPay";
import SubscriptionPanel from "./subscriptionPanel";
import { options } from "@config";
import { jwtDecode } from "jwt-decode";

type Subscription = {
  user: string;
  status?: string; // pending|authorized|paused|cancelled
  is_active?: boolean;
  is_delinquent?: boolean;
  payment_method_id?: string | null;
  last_charged_date?: string | null;
  next_payment_date?: string | null;
  raw?: any;
};

type UserResponse = {
  user?: string;
  email?: string;
  subscription?: Subscription | null;
};

type JwtPayload = { role?: string };

export default function BillsContent() {
  const [loading, setLoading] = React.useState(true);
  const [subscription, setSubscription] = React.useState<Subscription | null>(null);
  const [userId, setUserId] = React.useState<string>("");

  const token = localStorage.getItem("CLUB-VIP-JWT") || "";
  let isAdmin = false;
  try {
    if (token) {
      const decoded = jwtDecode<JwtPayload>(token);
      isAdmin = decoded?.role === "admin";
    }
  } catch {}

  React.useEffect(() => {
    const uid =
      localStorage.getItem("CLUB-VIP-USER") || "";

    setUserId(uid);

    const run = async () => {
      try {
        if (!uid) {
          setSubscription(null);
          setLoading(false);
          return;
        }

        const res = await fetch(`${options.api.url}userid?uid=${encodeURIComponent(uid)}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (!res.ok) {
          setSubscription(null);
          setLoading(false);
          return;
        }

        const data: UserResponse = await res.json();
        setSubscription(data.subscription || null);
      } catch (e) {
        setSubscription(null);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, []);

  return (
    <Box>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 1, sm: 1 },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{
            width: { xs: "100%", sm: "70%" },
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* CTA / Pago */}
          <Box sx={{ width: "100%" }}>
            <Pays subscription={subscription} userId={userId} />
          </Box>

          {/* Título (cambiado) */}
          <Box sx={{ width: "100%" }}>
            <Typography
              variant="body2"
              textAlign="center"
              fontFamily={fontBrand.principal}
              sx={{ color: "white", fontSize: { sm: "2vw", xs: "4.5vw" } }}
            >
              Estado de tu suscripción
            </Typography>
          </Box>

          {/* Panel de suscripción (cards) */}
          <Box sx={{ position: "relative", m: 1, width: "100%" }}>
            <SubscriptionPanel loading={loading} subscription={subscription} showRaw={isAdmin} />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
